export default __webpack_public_path__ + "static/media/shopping-basket-3.2db5ca89.png";